/**
 * Barrel for the Google provider. Exports the `MapConnector` and (stubbed)
 * `GeocodeConnector` so the resolver in `shared/maps/index.ts` can hand them
 * out without knowing about per-component files.
 *
 * The geocode connector is a stub in Phase 2 (#323) — full implementation
 * lands in Phase 3 (#324).
 */

import type { MapConnector } from '../../types';
import { GoogleMapView } from './GoogleMapView';
import { GoogleMarker } from './GoogleMarker';
import { GoogleAutocomplete } from './GoogleAutocomplete';
import { GooglePolyline } from './GooglePolyline';

export const googleMapsConnector: MapConnector = {
  name: 'google',
  MapView: GoogleMapView,
  Marker: GoogleMarker,
  Autocomplete: GoogleAutocomplete,
  Polyline: GooglePolyline,
};

export { googleGeocodeConnector } from './googleGeocode';
